import Vue from 'vue'
import PrimeVue from 'primevue/config'
import ToastService from 'primevue/toastservice'
import ConfirmationService from 'primevue/confirmationservice'
import Tooltip from 'primevue/tooltip'

import Accordion from 'primevue/accordion'
import AccordionTab from 'primevue/accordiontab'
import Button from 'primevue/button'
import Card from 'primevue/card'
import Chart from 'primevue/chart'
import Checkbox from 'primevue/checkbox'
import Chip from 'primevue/chip'
import Column from 'primevue/column'
import ConfirmDialog from 'primevue/confirmdialog'
import DataTable from 'primevue/datatable'
import Divider from 'primevue/divider'
import Dropdown from 'primevue/dropdown'
import InputNumber from 'primevue/inputnumber'
import InputSwitch from 'primevue/inputswitch'
import InputText from 'primevue/inputtext'
import Menu from 'primevue/menu'
import Message from 'primevue/message'
import Password from 'primevue/password'
import ProgressSpinner from 'primevue/progressspinner'
import SelectButton from 'primevue/selectbutton'
import TabPanel from 'primevue/tabpanel'
import TabView from 'primevue/tabview'
import Tag from 'primevue/tag'
import Dialog from 'primevue/dialog'
import Textarea from 'primevue/textarea'
import Toast from 'primevue/toast'
import Toolbar from 'primevue/toolbar'

import 'primevue/resources/themes/nova/theme.css'
import 'primevue/resources/primevue.min.css'
import 'primeicons/primeicons.css'

Vue.use(PrimeVue, { ripple: true })
Vue.use(ToastService)
Vue.use(ConfirmationService)
Vue.directive('tooltip', Tooltip)

Vue.component('Accordion', Accordion)
Vue.component('AccordionTab', AccordionTab)
Vue.component('Button', Button)
Vue.component('Card', Card)
Vue.component('Chart', Chart)
Vue.component('Checkbox', Checkbox)
Vue.component('Chip', Chip)
Vue.component('Column', Column)
Vue.component('ConfirmDialog', ConfirmDialog)
Vue.component('DataTable', DataTable)
Vue.component('Dialog', Dialog)
Vue.component('Divider', Divider)
Vue.component('Dropdown', Dropdown)
Vue.component('InputNumber', InputNumber)
Vue.component('InputSwitch', InputSwitch)
Vue.component('InputText', InputText)
Vue.component('Menu', Menu)
Vue.component('Message', Message)
Vue.component('Password', Password)
Vue.component('ProgressSpinner', ProgressSpinner)
Vue.component('SelectButton', SelectButton)
Vue.component('TabPanel', TabPanel)
Vue.component('TabView', TabView)
Vue.component('Tag', Tag)
Vue.component('Textarea', Textarea)
Vue.component('Toast', Toast)
Vue.component('Toolbar', Toolbar)
